import Vue from 'vue'
import Loading from '@/components/parts/Loading.vue'
import { addClass, removeClass, getStyle } from 'element-ui/src/utils/dom'
import { PopupManager } from 'element-ui/src/utils/popup'
import afterLeave from 'element-ui/src/utils/after-leave'

const Mask = Vue.extend(Loading)
const loadingDirective = {}

loadingDirective.install = (Vue) => {
  const keys_update = ['number', 'bar', 'title', 'search', 'tabs', 'sort', 'type']
  const retriveData = (el) => {
    return {
      type: el.getAttribute('l-type') || 'grid',
      number: el.getAttribute('l-number') || 9,
      bar: el.getAttribute('l-bar') !== 'false',
      title: el.getAttribute('l-title') !== 'false',
      search: el.getAttribute('l-search') === 'true',
      tabs: el.getAttribute('l-tabs') === 'true',
      sort: el.getAttribute('l-sort') === 'true',
      class: el.getAttribute('l-class'),
    }
  }
  const toggleLoading = (el, binding) => {
    if (binding.value) {
      Vue.nextTick(() => {
        if (binding.modifiers.fullscreen) {
          el.originalPosition = getStyle(document.body, 'position')
          el.originalOverflow = getStyle(document.body, 'overflow')
          el.maskStyle.zIndex = PopupManager.nextZIndex()

          addClass(el.mask, 'is-fullscreen')
          insertDom(document.body, el, binding)
        } else {
          removeClass(el.mask, 'is-fullscreen')

          if (binding.modifiers.body) {
            el.originalPosition = getStyle(document.body, 'position')
            ;['top', 'left'].forEach((property) => {
              const scroll = property === 'top' ? 'scrollTop' : 'scrollLeft'
              el.maskStyle[property] =
                el.getBoundingClientRect()[property] +
                document.body[scroll] +
                document.documentElement[scroll] -
                parseInt(getStyle(document.body, `margin-${property}`), 10) +
                'px'
            })
            ;['height', 'width'].forEach((property) => {
              el.maskStyle[property] = el.getBoundingClientRect()[property] + 'px'
            })

            insertDom(document.body, el, binding)
          } else {
            el.originalPosition = getStyle(el, 'position')
            insertDom(el, el, binding)
          }
        }
      })
    } else {
      afterLeave(
        el.instance,
        () => {
          if (!el.instance.hiding) return
          el.domVisible = false
          const target = binding.modifiers.fullscreen || binding.modifiers.body ? document.body : el
          removeClass(target, 'el-loading-parent--relative')
          removeClass(target, 'el-loading-parent--hidden')
          el.instance.hiding = false
        },
        300,
        true
      )
      el.instance.visible = false
      el.instance.hiding = true
    }
  }
  const insertDom = (parent, el, binding) => {
    if (!el.domVisible && getStyle(el, 'display') !== 'none' && getStyle(el, 'visibility') !== 'hidden') {
      Object.keys(el.maskStyle).forEach((property) => {
        el.mask.style[property] = el.maskStyle[property]
      })

      if (el.originalPosition !== 'absolute' && el.originalPosition !== 'fixed') {
        addClass(parent, 'el-loading-parent--relative')
      }
      if (binding.modifiers.fullscreen && binding.modifiers.lock) {
        addClass(parent, 'el-loading-parent--hidden')
      }
      el.domVisible = true

      parent.appendChild(el.mask)
      Vue.nextTick(() => {
        if (el.instance.hiding) {
          el.instance.$emit('after-leave')
        } else {
          el.instance.visible = true
        }
      })
      el.domInserted = true
    } else if (el.domVisible && el.instance.hiding === true) {
      el.instance.visible = true
      el.instance.hiding = false
    }
  }

  Vue.directive('loading-pld', {
    bind: function (el, binding, vnode) {
      const target = el.querySelector('.Loading__target')
      let elC = el
      if (target) {
        elC = target
      }
      var data = retriveData(elC)

      if (typeof data.number !== 'number') data.number = parseInt(data.number)
      const vm = vnode.context
      const mask = new Mask({
        el: document.createElement('div'),
        data: {
          type: data.type,
          bar: (vm && vm[data.bar]) || data.bar,
          title: (vm && vm[data.title]) || data.title,
          search: (vm && vm[data.search]) || data.search,
          tabs: (vm && vm[data.tabs]) || data.tabs,
          sort: (vm && vm[data.sort]) || data.sort,
          customClass: (vm && vm[data.class]) || data.class,
          numberItems: (vm && vm[data.number]) || data.number,
          fullscreen: !!binding.modifiers.fullscreen,
        },
      })
      el.instance = mask
      el.mask = mask.$el

      el.maskStyle = {}

      binding.value && toggleLoading(elC, binding)
    },

    update: function (el, binding) {
      const target = el.querySelector('.Loading__target')
      let elC = el
      if (target) {
        elC = target
      }

      const data = retriveData(elC)
      if (typeof data.number !== 'number') data.number = parseInt(data.number)

      for (let i = 0; i < keys_update.length; i++) {
        el.instance.update(keys_update[i], data[keys_update[i]])
      }

      if (binding.oldValue !== binding.value) {
        window.scroll(0, 0)
        toggleLoading(el, binding)
      }
    },

    unbind: function (el, binding) {
      if (el.domInserted) {
        el.mask && el.mask.parentNode && el.mask.parentNode.removeChild(el.mask)
        toggleLoading(el, { value: false, modifiers: binding.modifiers })
      }
      el.instance && el.instance.$destroy()
    },
  })
}

export default loadingDirective
